import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../styles/dashboard.css";

export default function Dashboard() {
  const { user, organization, signOut } = useAuth();
  const initials = (user?.firstName?.[0] || "") + (user?.lastName?.[0] || "");

  return (
    <div className="dashboard-layout">
      <aside className="sidebar">
        <div className="sidebar-brand">
          <h2>Business System</h2>
          <div className="org-name">{organization?.name}</div>
        </div>

        <nav className="sidebar-nav">
          <NavLink to="/dashboard" end>📊 Overview</NavLink>
          <NavLink to="/dashboard/pos">💳 POS</NavLink>
          <NavLink to="/dashboard/sales">🧾 Sales</NavLink>
          <NavLink to="/dashboard/inventory">📦 Inventory</NavLink>
          <NavLink to="/dashboard/tools">🧰 Tools</NavLink>
          <NavLink to="/dashboard/organization">🏢 Organization</NavLink>
          <NavLink to="/dashboard/feedback">💬 Feedback</NavLink>
          <NavLink to="/dashboard/settings">⚙️ Settings</NavLink>
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="avatar">{initials}</div>
            <div>
              <div className="user-name">{user?.firstName} {user?.lastName}</div>
              <div className="user-email">{user?.email}</div>
            </div>
          </div>
          <button onClick={signOut}>Sign Out</button>
        </div>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
